export default "__VITE_ASSET__6099e1bb__"